/*
 * Sticky add to cart.
 *
 * The bar owns no product form. It proxies the real add-to-cart button in the
 * main product section and mirrors the real price element, so variant changes,
 * quantity, sold-out state and Dawn's own cart-drawer behaviour all keep
 * working without being reimplemented here.
 *
 * Visibility is driven by an IntersectionObserver on the real buy button: the
 * bar is hidden while that button is on screen and shown once it is not.
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-resemble-sticky-atc]');
  if (!bar) return;

  // The real button, explicitly not the one inside this bar.
  var mainButton = null;
  var candidates = document.querySelectorAll('.product-form__submit');
  for (var i = 0; i < candidates.length; i++) {
    if (!bar.contains(candidates[i])) {
      mainButton = candidates[i];
      break;
    }
  }

  // With no buy button on the page there is nothing to proxy, so the bar would
  // be a dead control. Leaving it hidden is the honest outcome.
  if (!mainButton) return;

  var proxyButton = bar.querySelector('[data-sticky-atc-button]');
  var priceEl = bar.querySelector('[data-sticky-atc-price]');
  var mainPrice = document.querySelector('.product__info-container .price');

  /* Clicking the proxy clicks the real button. Not form.requestSubmit():
     Dawn intercepts the click to open the cart drawer, and requestSubmit
     would bypass that and do a full page navigation instead. */
  proxyButton.addEventListener('click', function () {
    mainButton.click();
  });

  /* Dawn renders the regular price, the sale price and the Sale and Sold out
     badges all at once and hides the ones that do not apply with CSS. It also
     carries `.visually-hidden` labels for screen readers. `textContent` on the
     whole node flattens every one of those, so the bar read
     "Regular price 2,490.00 PKR Regular price 0.00 PKR Sale price 2,490.00 PKR
     Sale Sold out".

     Which block is live is decided by `price--on-sale` on the container, so
     that is what picks the selector. `getClientRects()` is then the check that
     the chosen node is really being drawn, which covers any other node Dawn
     hides without this file having to know the class it used. */
  function visiblePriceText(node) {
    var onSale = node.classList.contains('price--on-sale');
    var items = node.querySelectorAll(onSale ? '.price-item--sale' : '.price-item--regular');

    for (var i = 0; i < items.length; i++) {
      var text = items[i].textContent.replace(/\s+/g, ' ').trim();
      if (text && items[i].getClientRects().length) return text;
    }

    return '';
  }

  function syncState() {
    var disabled = mainButton.hasAttribute('disabled');
    proxyButton.disabled = disabled;

    if (priceEl && mainPrice) {
      var text = visiblePriceText(mainPrice);
      if (text) priceEl.textContent = text;
    }
  }

  syncState();

  /* Dawn re-renders the price and the buy button on every variant change, so
     watching the DOM covers all of its variant events at once without this
     file having to know which ones exist in a given Dawn version. */
  var mo = new MutationObserver(syncState);
  mo.observe(mainButton, { attributes: true, attributeFilter: ['disabled'] });
  if (mainPrice) {
    mo.observe(mainPrice, { childList: true, subtree: true, characterData: true });
  }

  var offset = parseInt(bar.dataset.revealOffset || '0', 10) || 0;

  if (!('IntersectionObserver' in window)) {
    bar.hidden = false;
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      // Hidden while the real button is in view, shown once it is not.
      bar.hidden = entries[0].isIntersecting;
    },
    { rootMargin: offset + 'px 0px 0px 0px', threshold: 0 }
  );

  io.observe(mainButton);
})();
